import React from 'react';
import OverlayNav from './variants/OverlayNav';
import HeaderNav from './variants/HeaderNav';
import MobileNav from './variants/MobileNav';
import MobileHeader from './components/MobileHeader';
import { useNavigation } from './hooks/useNavigation';
import { navigationConfig } from './data/navigationData';
import './styles/UnifiedNavigation.css';
import './styles/variants.css';
import './styles/responsive.css';

const UnifiedNavigation = ({
  variant = 'header', // 'overlay' | 'header' | 'mobile'
  currentPage,
  showLogo,
  showJoinButton,
  className = ''
}) => {
  const {
    isMobile,
    isOpen,
    dropdownVisible,
    activeDropdownItem,
    toggleMenu,
    toggleDropdown,
    handleDropdownItemClick,
    closeMobileMenu
  } = useNavigation();

  // Override show flags based on variant and config
  const shouldShowLogo = showLogo !== undefined 
    ? showLogo 
    : (variant === 'overlay' && navigationConfig.logo.showOnOverlay);

  const shouldShowJoinButton = showJoinButton !== undefined
    ? showJoinButton
    : (variant === 'overlay' && navigationConfig.joinButton.showOnOverlay) ||
      (variant === 'mobile' && navigationConfig.joinButton.showOnMobile);

  return (
    <div className={`unified-navigation ${variant} ${className}`}>
        {/* Desktop Navigation */}
        {!isMobile && (
          <>
            {variant === 'overlay' && (
              <OverlayNav
                currentPage={currentPage}
                showLogo={shouldShowLogo}
                showJoinButton={shouldShowJoinButton}
                dropdownVisible={dropdownVisible}
                activeDropdownItem={activeDropdownItem}
                onToggleDropdown={toggleDropdown}
                onItemClick={handleDropdownItemClick}
              />
            )}
            {variant === 'header' && (
              <HeaderNav
                currentPage={currentPage}
              />
            )}
          </>
        )}

        {/* Mobile Navigation */}
        {isMobile && (
          <>
            <MobileHeader 
              isOpen={isOpen}
              onToggle={toggleMenu}
            />
            <MobileNav
              currentPage={currentPage}
              isOpen={isOpen}
              toggleMenu={toggleMenu}
              onLinkClick={closeMobileMenu}
            />
          </>
        )}
    </div>
  );
};

export default UnifiedNavigation;